<template>
  <div
    ref="progressBar"
    class="progress-bar"
  ></div>
</template>

<script>
export default {
  props: {
    topElement: {
      type: String,
      default: '',
    },
    bottomElement: {
      type: String,
      default: '',
    },
  },
  watch: {
    $route() {
      this.$refs.progressBar.style.setProperty('--scroll', 0);
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
    this.onScroll();
  },
  beforeUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      const documentElementScrollTop = document.documentElement.scrollTop;
      const bodyScrollTop = document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeightOffset = 72;
      const minPercent = 0;
      const maxPercent = 100;

      const bodyRect = document.querySelector('body').getBoundingClientRect();
      const top = this.topElement
        ? document
            .getElementById(this.topElement.substring(1))
            ?.getBoundingClientRect()?.top
        : bodyRect.top;
      const bottom = this.bottomElement
        ? document
            .getElementById(this.bottomElement.substring(1))
            ?.getBoundingClientRect()?.bottom
        : bodyRect.bottom;

      const scrollTop = this.topElement
        ? (documentElementScrollTop || bodyScrollTop) -
          (window.scrollY + top) +
          72
        : documentElementScrollTop || bodyScrollTop;

      const scrollHeight =
        Math.abs(top) + Math.abs(bottom) - (clientHeight - scrollHeightOffset);

      const scrollPercent =
        bottom > minPercent
          ? (scrollTop / scrollHeight) * maxPercent
          : maxPercent;

      this.$refs?.progressBar.style.setProperty(
        '--scroll',
        `${scrollPercent}%`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ProgressBar.scss';
</style>
